import { Box, IconButton } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, NoteAdd as NoteAddIcon } from '@mui/icons-material';

function StepActions({ onEdit, onDelete, onAddNote, size = 'small' }) {
  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <IconButton size={size} onClick={onEdit} title="Edit Step">
        <EditIcon fontSize={size} />
      </IconButton>
      <IconButton size={size} onClick={onDelete} title="Delete Step">
        <DeleteIcon fontSize={size} />
      </IconButton>
      <IconButton size={size} onClick={onAddNote} title="Add Note">
        <NoteAddIcon fontSize={size} />
      </IconButton>
    </Box>
  );
}

export default StepActions;
